import { render, staticRenderFns } from "./RetakeGuide.vue?vue&type=template&id=386ce3be&scoped=true&"
import script from "./RetakeGuide.vue?vue&type=script&lang=js&"
export * from "./RetakeGuide.vue?vue&type=script&lang=js&"
import style0 from "./RetakeGuide.vue?vue&type=style&index=0&id=386ce3be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386ce3be",
  null
  
)

export default component.exports